import axios from 'axios';

import { RESPONSE_STATUSES, DASHBOARD_COMPANY, COMPANY_TYPE } from 'constants';

import { apiManager } from './apiManager';

const base_url = process.env.REACT_APP_API_URL;

const instance = axios.create({
  baseURL: base_url,
  headers: {[COMPANY_TYPE]: [DASHBOARD_COMPANY]}
});

export const authApi = {
  login: async (params) => {
    const res = instance.post(`/dashboard/login`, params);
    res.catch((err) => {
      if (err.response.status === RESPONSE_STATUSES.unauthorized) {
        localStorage.removeItem('access_token');
      }
    });
    return res;
  },
  signUp: async (params) => instance.post(`${base_url}/dashboard/signup`, params),
  logout: async () => apiManager.post('/dashboard/logout'),
  getUser: async () => apiManager.get('/dashboard/user'),
  forgotPassword: async (params) =>
    apiManager.post('/dashboard/forgot-password', params, {[COMPANY_TYPE]: [DASHBOARD_COMPANY]}),
  resetPassword: async (params) =>
    apiManager.post('/dashboard/reset-password', params),
};
